import CommonUtil from "./utility";
import { authProps } from "./viewUtility";

export const StorageUtil = {
	saveData(key: string, data: string) {
		localStorage.setItem(key, data);
	},
	saveObject(key: string, data: any) {
		if (CommonUtil.isNotNull(data)) {
			this.saveData(key, JSON.stringify(data));
		}
	},
	getData(key: string): string | null {
		return localStorage.getItem(key);
	},

	getObject(key: string) {
		const obj = this.getData(key);
		if (CommonUtil.isNotNull(obj)) {
			return JSON.parse(obj as string);
		}
	},

	removeData(key: string) {
		localStorage.removeItem(key);
	},

	removeAll() {
		const exceptValue = localStorage.getItem(authProps.MAJOR_VERSION);
		// Clear all items in localStorage except major version
		localStorage.clear();
		if (exceptValue !== null) {
			localStorage.setItem(authProps.MAJOR_VERSION, exceptValue);
		}
	},

	hasKey(key: string) {
		return CommonUtil.isNotNull(localStorage.getItem(key));
	},
};

export default StorageUtil;
